import {Grid, Typography, Button, useTheme} from "@mui/material";
import React from "react";
import {LoadingSkeleton} from "../../atoms/LoadingSkeleton/LoadingSkeleton";

interface ButtonConfig {
    label: string;
    sdqlCondition: string;
    hide?: boolean;
}

interface ButtonRowProps {
    xs?: number;
    md?: number;
    lg?: number;
    xl?: number;
    mt?: number;
    mr?: number;
    mb?: number;
    ml?: number;
    label?: string;
    loading?: boolean;
    queryString: string;
    justifyContent?: string;
    flexDirection?: string;
    handleChange: (sdqlCondition: string, reset: boolean) => void;
    buttonConfigs: ButtonConfig[];
}

export const QueryStringButtonGroup = ({
                                           xs,
                                           md,
                                           lg,
                                           xl,
                                           mt,
                                           mb,
                                           ml,
                                           mr,
                                           label,
                                           loading = false,
                                           justifyContent = 'center',
                                           flexDirection = 'row',
                                           queryString,
                                           handleChange,
                                           buttonConfigs
                                       }: ButtonRowProps) => {
    const theme = useTheme()

    if(loading || !buttonConfigs?.length) return (
        <Grid
            item
            container
            display="flex"
            flexDirection={'row'}
            justifyContent={justifyContent}
            flexWrap="wrap"
            mt={mt}
            mr={mr}
            mb={mb}
            xs={xs}
            md={md}
            lg={lg}
            xl={xl}
            ml={ml}
        >
            <LoadingSkeleton height={15} width={45} />
        </Grid>
    )

    return (
        <Grid
            item
            container
            display="flex"
            flexDirection={flexDirection || buttonConfigs.length > 3 ? 'column' : 'row'}
            justifyContent={justifyContent || "space-between"}
            flexWrap="wrap"
            mt={mt}
            mb={mb}
            xs={xs}
            md={md}
            lg={lg}
            xl={xl}
            ml={ml}
            mr={mr}
        >
            <Grid item container spacing={1} justifyContent="center" flexWrap="wrap">
                {label && buttonConfigs?.length ?
                    <Typography
                        variant="caption"
                        align="center"
                        component="span"
                        alignContent="center"
                        color={theme.palette.grey[500]}
                    >
                        {label}
                    </Typography> :
                    null
                }
                {buttonConfigs?.map((config: ButtonConfig, index: number) => {
                    const { label, sdqlCondition, hide } = config;
                    if (hide) return null;

                    // const getButtonVariant = (sdqlCondition: string) => {
                    //     const trimmedQueryString = queryString.trim();
                    //     const trimmedSdqlCondition = ` ${sdqlCondition.trim()}`;
                    //     const regex = new RegExp(`(^|\\s)${sdqlCondition.trim()}`);
                    //     if (trimmedSdqlCondition.includes('season')) {
                    //         return trimmedQueryString.includes(sdqlCondition) ? 'contained' : 'outlined';
                    //     }
                    //     // return trimmedQueryString.includes(trimmedSdqlCondition) ? 'contained' : 'outlined';
                    //     return regex.test(trimmedSdqlCondition) ? 'contained' : 'outlined';
                    // };
                    const getButtonVariant = (sdqlCondition: string) => {
                        const trimmedQueryString = queryString.trim();
                        const trimmedSdqlCondition = sdqlCondition.trim();

                        // Regex: Enforce a space or start of string before the condition, no space requirement after
                        const regex = new RegExp(`(^|\\s)${trimmedSdqlCondition}(\\s|$)`);

                        // const isConditionPresent = (query: string, condition: string) => regex.test(query);

                        if (sdqlCondition.includes('season')) {
                            return trimmedQueryString.includes(sdqlCondition) ? 'contained' : 'outlined';
                        }
                        return trimmedQueryString.includes(` ${sdqlCondition}`) ? 'contained' : 'outlined';
                        // return isConditionPresent(trimmedQueryString, trimmedSdqlCondition) ? 'contained' : 'outlined';
                    };
                    return (
                        <Grid item key={index}>
                            <Button
                                onClick={() => handleChange(sdqlCondition, false)}
                                variant={getButtonVariant(sdqlCondition)}
                                size="small"
                            >
                                <Typography variant="caption">
                                    {label}
                                </Typography>
                            </Button>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
};